import Abstract1 from "./Images/Abstract1.png";
import Abstract2 from "./Images/Abstract2.png";
import Abstract3 from "./Images/Abstract3.png";
import Abstract4 from "./Images/Abstract4.png";
import Abstract5 from "./Images/Abstract5.png";
import Abstract6 from "./Images/Abstract6.png";
import Abstract7 from "./Images/Abstract7.png";
import Abstract8 from "./Images/Abstract8.png";
import Abstract9 from "./Images/Abstract9.png";
import Abstract10 from "./Images/Abstract10.png";
import Abstract11 from "./Images/Abstract11.png";
import Abstract12 from "./Images/Abstract12.png";

export const cardImages = [
  { src: Abstract1, matched: false },
  { src: Abstract2, matched: false },
  { src: Abstract3, matched: false },
  { src: Abstract4, matched: false },
  { src: Abstract5, matched: false },
  { src: Abstract6, matched: false },
  { src: Abstract7, matched: false },
  { src: Abstract8, matched: false },
  { src: Abstract9, matched: false },
  { src: Abstract10, matched: false },
  { src: Abstract11, matched: false },
  { src: Abstract12, matched: false },
];
